/**
 * Feedback SDK Configuration Constants
 *
 * These values configure the Microsoft InApp Feedback SDK.
 * Update these constants when changing environments (dev/prod) or SDK versions.
 */

/**
 * Microsoft InApp Feedback SDK Application ID
 * - Dev/Int: 50461
 * - Prod: 3022 (update when deploying to production)
 */
export const FEEDBACK_APP_ID = 3022;

/**
 * SDK Host Name for feedback initialization
 * This identifies the host application to the Microsoft Feedback service
 */
export const FEEDBACK_HOST_NAME = "BYOD";

/**
 * Environment flag for feedback SDK
 * Set to true when deploying to production
 */
export const FEEDBACK_IS_PRODUCTION = true;

/**
 * Cloud Policy Service (CPS) caller application hint
 * Used for CPS policy evaluation and logging
 */
export const FEEDBACK_CPS_CALLER_HINT = "FrontlineBYODWizard";
